import Main from "./pages/MainNew";
import Project from "./pages/Project";
import About from "./pages/About";
import Mobile from "./pages/Mobile";
import ProjectMobile from "./pages/ProjectMobile";
import GlobalStyle from "./globalStyles";
import { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { use } from "react";

export default function App() {
  const [context, setContext] = useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth < 800) {
      setMobile(true);
    }
  }, []);

  return (
    <Router>
      {/* <AboutContext.Provider value={[context, setContext]}> */}
      <div className="App">
        <GlobalStyle />
        {window.innerWidth >= 800 && (
          <Routes>
            <Route index path="/" element={<Main />} />
            <Route index path="/project" element={<Project />} />
            <Route path="/about" element={<About />} />
          </Routes>
        )}
        {window.innerWidth < 800 && (
          <Routes>
            <Route index path="/" element={<Mobile />} />
            {/* <Route index path="/" element={<Main />} /> */}
            <Route path="/project" element={<Project />} />
            <Route path="/projectMobile" element={<ProjectMobile />} />
          </Routes>
        )}
      </div>
      {/* </AboutContext.Provider> */}
    </Router>
  );
}
